<template>
  <div class="">
    <v-row>
      <v-col class="pa-8" cols="12">
        <v-card
          class="text-center mx-auto pa-6 pb-8"
          flat=""
          max-width="448"
          rounded="lg"
        >
         

          <div class="text-h4 font-weight-bold mb-4">Registe-se</div>
          <div class="text-body-2 mb-4">
            E mude a forma como gere as suas páginas
          </div>
          
          <!-- Error Message -->
          <div v-if="errorMessage" class="text-red mb-4">{{ errorMessage }}</div>

          <v-container>
            <v-text-field
              v-model="username"
              density="compact"
              color="primary"
              label="username"
              variant="outlined"
              :rules="usernameRules"
              hide-details=""
              class="my-3"
              :error="!username && errorMessage"
            ></v-text-field>

            <v-text-field
              v-model="email"
              density="compact"
              color="primary"
              label="Email"
              variant="outlined"
              hide-details=""
              class="my-3"
              :rules="emailRules"
              :error="!email && errorMessage"
            ></v-text-field>
            <v-text-field
              v-model="contact"
              density="compact"
              color="primary"
              label="Contacto"
              variant="outlined"
              hide-details=""
              class="my-3"
              :rules="contactRules"
              :error="!contact && errorMessage"
            ></v-text-field>
            <v-text-field
              v-model="website"
              density="compact"
              color="primary"
              label="Link do Website"
              variant="outlined"
              hide-details=""
              class="my-3"
              :rules="websiteRules"
            ></v-text-field>
            <v-text-field
              v-model="databases"
              density="compact"
              color="primary"
              label="Databases"
              variant="outlined"
              hide-details=""
              class="my-3"
              :rules="databasesRules"
            ></v-text-field>
            <v-select
              label="Selecione a categoria"
              density="compact"
              hide-details=""
              variant="outlined"
              class="my-3"
              :items="[
                'Rent a car',
                'Calçado e Acessórios',
                'Mercearia',
                'Catering',
                'e-learning',
              ]"
              v-model="category"
              :rules="categoryRules"
              :error="!category && errorMessage"
            ></v-select>
            <v-text-field
              v-model="password"
              :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
              :type="visible ? 'text' : 'password'"
              density="compact"
              color="primary"
              label="Password"
              placeholder="Crie uma palavra-passe"
              variant="outlined"
              hide-details=""
              class="my-3"
              :rules="passwordRules"
              @click:append-inner="visible = !visible"
              :error="!password && errorMessage"
            ></v-text-field>

            <v-checkbox
              v-model="terms"
              color="secondary"
              density="compact"
              label="Concordo com os termos e condições"
              :rules="termsRules"
              hide-details=""
            ></v-checkbox>
          </v-container>
          <v-card-actions>
            <v-btn
              @click="registerUser"
              :disabled="!isFormValid"
              :loading="loading"
              block
              color="blue"
              size="large"
              variant="tonal"
            >
              Finalizar registo
            </v-btn>
          </v-card-actions>
          <div class="text-center text-body-2 mb-8">
            Já tenho uma conta
            <router-link to="/login" class="text-blue text-decoration-none">
              Fazer Login
            </router-link>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import axios from "axios";

export default {
  data: () => ({
    username: null,
    email: null,
    contact: null,
    visible: false,
    website: null,
    loading: false,
    category: null,
    databases: null,
    password: null,
    terms: false,
    errorMessage: "", // Error message state
    usernameRules: [(v) => !!v || "username é obrigatório"],
    emailRules: [
      (v) => !!v || "Email é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "Email deve ser válido",
    ],
    contactRules: [(v) => !!v || "Contacto é obrigatório"],
    categoryRules: [(v) => !!v || "Categoria é obrigatória"],
    websiteRules: [], // Add validation rules for website if needed
    passwordRules: [
      (v) => !!v || "Palavra-passe é obrigatória",
      (v) =>
        (v && v.length >= 6) ||
        "Palavra-passe deve ter pelo menos 6 caracteres",
    ],
    termsRules: [
      (v) => !!v || "É necessário concordar com os termos e condições",
    ],
  }),

  computed: {
    isFormValid() {
      return (
        this.usernameRules.every((rule) => rule(this.username)) &&
        this.emailRules.every((rule) => rule(this.email)) &&
        this.contactRules.every((rule) => rule(this.contact)) &&
        this.categoryRules.every((rule) => rule(this.category)) &&
        this.websiteRules.every((rule) => rule(this.website)) &&
        this.databasesRules.every((rule) => rule(this.databases)) &&
        this.passwordRules.every((rule) => rule(this.password)) &&
        this.termsRules.every((rule) => rule(this.terms))
      );
    },
  },

  methods: {
    async registerUser() {
      if (!this.isFormValid) {
        this.errorMessage = "Os campos obrigatórios devem ser preenchidos";
        return;
      }

      this.loading = true; // Show progress bar
      this.errorMessage = ""; // Reset error message
      try {
        const response = await axios.post("http://localhost:3000/api/register", {
          username: this.username,
          email: this.email,
          contact: this.contact,
          website: this.website,
          databases: this.databases,
          category: this.category,
          password: this.password,
        });

        console.log(response.data.message);
        // Redirect to the login page or home page as needed
        this.$router.push("/login"); // Assuming you are using Vue Router
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.errorMessage = "Este usuário já foi registado, faça login ou use um email diferente";
        } else {
          this.errorMessage = "Erro ao registrar usuário, tente novamente mais tarde";
        }
        console.error("Error registering user:", error);
      } finally {
        this.loading = false; // Hide progress bar
      }
    },
  },
};
</script>


<style scoped>
.bg_decor {
  width: 100%;
  height: 100vh;
  background-color: beige;
}
.play {
  width: 100%;
  height: 100%;
  background-color: blue;
}
</style>
